import { physicalStockKeys, useNodeService } from "@fero/hooks";
import type {
  OrganisationId,
  StorageLocationId,
} from "adl-gen/ferovinum/app/db";

export const useGetStockQuery = (
  organisationId: OrganisationId,
  storageLocationId: StorageLocationId,
  holdId?: string,
  releaseId?: string,
) => {
  const service = useNodeService();

  const request = {
    organisation: organisationId,
    location: storageLocationId,
    ...(holdId && { reservation: holdId }),
    ...(releaseId && { release: releaseId }),
  };

  const result = service.physicalStock.reservables.useQuery(
    physicalStockKeys.getStock(
      organisationId,
      storageLocationId,
      holdId,
      releaseId,
    ),
    {
      query: request,
    },
  );

  return {
    ...result,
    data: result.data?.body ?? [],
  };
};
